import React, { useContext } from 'react';
import Select from '../components/Select';
import i18n from '~/i18n';
import { OrderContext } from '~/App/Layout/providers/OrderProvider';
import {
  checkIsRequireTableNumber,
  ORDER_TYPE_OPTIONS,
} from '@restaurant/constants';
import { OrderType } from '@restaurant/types';

const SelectOrderType = () => {
  const { order, setOrder } = useContext(OrderContext);

  const onChange = async (value: OrderType) => {
    if (!order.isNew) return;

    setOrder({
      ...order,
      orderType: value,
      ...(!checkIsRequireTableNumber(value) ? { tableNumber: null } : {}),
      ...(value !== OrderType.Indent ? { delivery: null } : {}),
    });
  };

  return (
    <Select
      disabled={!order.isNew}
      options={ORDER_TYPE_OPTIONS}
      value={order.orderType}
      onChange={onChange}
      placeholder={i18n.t('order_info_choose_type')}
    />
  );
};

export default SelectOrderType;
